module.exports = __webpack_public_path__ + "img/bar-arrow@3x.0d0c4201.png";